import { useLang } from "../../context/LanguageContext";

interface DocumentDeleteConfirmModalProps {
  open: boolean;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Confirmation before removing an uploaded session document - matches residence proof-of-stay UX.
 */
export default function DocumentDeleteConfirmModal({
  open,
  busy,
  onConfirm,
  onCancel,
}: DocumentDeleteConfirmModalProps) {
  const { t } = useLang();
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center px-4"
      style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
      onClick={() => !busy && onCancel()}
    >
      <div
        className="w-full max-w-[400px] bg-white rounded-2xl px-5 pt-5 pb-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="text-[15px] text-slate-800 mb-5 leading-snug">{t("docUpload.deleteFileConfirm")}</p>
        <div className="flex flex-col gap-2.5">
          <button
            type="button"
            disabled={busy}
            onClick={onConfirm}
            className="w-full py-3.5 rounded-xl bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white text-[15px] font-semibold cursor-pointer transition-colors whitespace-nowrap"
          >
            {busy ? "…" : t("documentScanner.reviewDeleteConfirmDelete")}
          </button>
          <button
            type="button"
            disabled={busy}
            onClick={onCancel}
            className="w-full py-3.5 rounded-xl bg-white border border-slate-200 hover:border-slate-300 text-slate-700 text-[15px] font-medium cursor-pointer transition-colors whitespace-nowrap"
          >
            {t("documentScanner.reviewDeleteConfirmCancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
